module.exports = __webpack_public_path__ + "img/endless_possibilities.fe22165.jpg";